import * as React from 'react'
import { useSignupContext } from '../../context/signup'
import { ProductSelection } from '../ProductSelection'
import { SignupForm } from '../SignupForm'
import { useRegistrationLinkHandler, useRegistrationForm } from '../SignupForm/hooks'
import { navigate } from 'gatsby'
import { isServer } from '../../../../lib/utils'

export const FreeTrial = () => {
    const {
        step,
        setStep,
        productName,
        setProductName,
        productVariant,
        setProductVariant,
        operatingSystem,
        setOperatingSystem,
        setEmail,
    } = useSignupContext();

    const sublineRef = React.useRef<HTMLParagraphElement>(null)
    const { handleSubmit, currentOption, isValid, loading, error } = useRegistrationForm()
    useRegistrationLinkHandler(sublineRef, { productName, productVariant, operatingSystem })

    const renderStepBasedOnProduct = React.useCallback(() => {
        const searchParams = new URLSearchParams(window.location.search.replace('?', ''))
        const productCode = searchParams.get('product_code');

        if (productCode === '_CONVSRV') {
            setProductVariant('Full Edition');
            setOperatingSystem('');
            setStep(1);
        } else if (productCode === '_PDFSDK') {
            setProductVariant('Unlimited Trial');
            setOperatingSystem('');
            setStep(1);
        } else if (productCode === '_PRN') {
            setProductVariant('');
            setOperatingSystem('');
            setStep(0);
        } else if (productCode === '_REP') {
            setProductVariant('');
            setOperatingSystem('');
            setStep(0);
        } else if (productCode === '_VIEWWEB') {
            setProductVariant('Standard Edition');
            setOperatingSystem('');
            setStep(1);
        }

    }, [productName, productVariant, operatingSystem])

    React.useEffect(() => {
        if (isServer()) return
        const searchParams = new URLSearchParams(window.location.search.replace('?', ''))
        const email = searchParams.get('email')
        if (email || email === '') {
            setEmail(email);
            renderStepBasedOnProduct();
        }

    }, [])

    const renderStep = React.useMemo(() => {
        if (step === 0) {
            return (<ProductSelection />)
        } else if (step === 1) {
            return (<SignupForm loading={loading} isValid={isValid} error={error} currentOption={currentOption} />)
        }
    }, [step, loading, isValid, error, currentOption])

    const product = React.useMemo(() => {
        if (!isServer()) {
            const searchParams = new URLSearchParams(window.location.search.replace('?', ''))
            const productCode = searchParams.get('product_code')
            return productCode || ''
        }

        return ''
    }, []);

    React.useEffect(() => {
        if (product) {
            setProductName(product);
        }
    }, [])

    return (
        <form onSubmit={handleSubmit}>
            {renderStep}
        </form>
    )
}